import * as React from 'react';
export const firstcitizensSvg = React.forwardRef(function firstcitizensSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#1C4FB2',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.336 8.83a3.096 3.096 0 0 0-1.969 1.653 1.972 1.972 0 0 0-.188.782v1.662c0 .159-.08.307-.228.376-.079.03-.158.08-.227.13l-.228.098-7.49 2.87v10.58h4.938v-1.01l3.67-1.484.287-.1c.248-.098.475-.237.683-.405a2.422 2.422 0 0 0 1.177-1.95V20.3l9.34-3.899V5l-9.765 3.83Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm16.895 13.431 8.025-3.147V6.82l-8.124 3.177c-1.01.376-1.316.802-1.316 1.544v1.593c0 1.1-1.554 1.564-1.554 1.564L6 17.756V27h3.612v-1.86l4.374-1.742s1.316-.436 1.316-1.485V20.31a1.553 1.553 0 0 1 1.039-1.316l8.51-3.296v-3.484l-8.194 3.236c-1.039.406-1.177.871-1.177.871v-1.554c0-.138 0-.672 1.415-1.326v-.01Zm-1.603 5.365a1.19 1.19 0 0 1-.742.97 67.017 67.017 0 0 1-4.889 1.91v-1.821a268.807 268.807 0 0 0 5.067-2.01 2.04 2.04 0 0 0 .554-.534v1.485h.01Z',
      fill: '#B92F41',
    }),
  );
});
firstcitizensSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var firstcitizens = {
  category: 'brand',
  colorable: false,
  name: 'firstcitizens',
  svg: firstcitizensSvg,
};
